import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/interceptors/auth.guard";
import { FormTripPage } from './caller/form-trip/form-trip.page';

const routes: Routes = [
  { path: "*", redirectTo: "login", pathMatch: "full" },
  {
    path: "call",
    loadChildren: () => import('./caller/caller.module').then(m => m.CallPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "driver",
    loadChildren: () => import('./driver/driver.module').then(m => m.DriverModule),
    canActivate: [AuthGuard]
  },
  {
    path: "form-trip/:id",
    component: FormTripPage
  },
  {
    path: "form-restaurant/:id",
    component: FormTripPage
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      enableViewTransitions: true,
      useHash: true
    })
  ],
  providers: [AuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
